import { Component, ojs, app, payload } from "modular-openscriptjs";
import { tool, dom } from "../../fotastart";
import { either, empty, eParse, oneOf } from "../../helpers";
import { $e } from "../../ojs.events";

const h = app("h");
const broker = app("broker");

export default class PaymentRequestForm extends Component {
    render(request, ...args) {
        if(empty(request)) return h.empty();
    }

    renderForm(request, ...args) {
        return h.div(
            { class: "container" },
            h.input({
                type: "hidden",
                class: "form-control",
                id: "request-order-id",
                value: oneOf(request?.orderId, 0),
            }),
            h.div(
                { class: "mb-3" },
                h.input({
                    type: "number",
                    class: "form-control",
                    placeholder: "Amount",
                    id: "request-input-amount",
                }),
            ),
            h.div(
                { class: "mb-3" },
                h.select(
                    { class: "form-select", id: "request-input-purpose" },
                    h.option(
                        { value: "purchase" },
                        "Purchase",
                        either(request?.purpose == "purchase", {
                            selected: true,
                        }),
                    ),
                    h.option(
                        { value: "delivery" },
                        "Delivery",
                        either(request?.purpose == "delivery", {
                            selected: true,
                        }),
                    ),
                ),
            ),
            h.div(
                { class: "mb-3" },
                h.textarea(
                    {
                        class: "form-control",
                        placeholder: "Why are you making the request",
                        id: "request-input-description",
                    },
                    either(
                        request?.purpose == "delivery",
                        "The delivery fee is unfair",
                        "The prices of some items have changed",
                    ),
                ),
            ),
            ...args,
        );
    }

    $$paymentRequest = {
        stored: (ed, event) => {
            let data = eParse(ed);
            dom.id(data.meta.buttons.left)?.click();
        },

        needs: {
            requestForm: (ed, event) => this.showForm(ed),
        },

        has: {
            storageError: (ed, event) => {
                let data = eParse(ed);
                const btn = dom.id(data.meta.buttons.right);

                dom.enable(btn);
                dom.put("Request", btn);
            },
        },
    };

    async showForm(ed, event) {
        let data = eParse(ed);

        let options = new tool.ModalOptions();
        options.buttons.right.text = "Request";

        const { buttons } = tool.modal(
            "Request Payment",
            this.renderForm(data.message.get("request")),
            options,
        );

        buttons.right.button.addEventListener("click", function () {
            dom.disable(this);
            dom.put("Requesting...", this);

            broker.send(
                $e.paymentRequest.needs.storage,
                payload(
                    {
                        order_id: dom.id("request-order-id")?.value,
                        purpose: dom.id("request-input-purpose")?.value,
                        amount: dom.id("request-input-amount")?.value,
                        description: dom.id("request-input-description")?.value,
                    },
                    {
                        buttons: {
                            left: buttons.left.button.id,
                            right: buttons.right.button.id,
                        },
                    },
                ),
            );
        });
    }
}
